// ui/src/Forms/Loaders/components/TextAreaSkeleton.js
import { Mui } from "@osu/react-ui";

function TextAreaSkeleton() {
  return (
    <Mui.Box sx={{ mb: 3 }}>
      <Mui.Skeleton variant="text" width="55%" height={24} />
      <Mui.Skeleton variant="rectangular" width="100%" height={120} />
    </Mui.Box>
  );
}

export default TextAreaSkeleton;
